//#region src/passkeys/native/parsePasskeyReturn.ts
var e = {
	purpose: ["purpose"],
	verified: ["verified"],
	transactionId: ["transactionid", "transaction_id"],
	resultToken: ["resulttoken", "result_token"],
	code: ["code", "reason"]
}, t = new Set([
	"true",
	"1",
	"yes"
]), n = (e) => {
	let t = /* @__PURE__ */ new Map();
	for (let n of ["?", "#"]) {
		let r = e.indexOf(n);
		if (r === -1) continue;
		let i = e.slice(r + 1), a = i.search(n === "?" ? /#/ : /\?/), o = a === -1 ? i : i.slice(0, a);
		for (let e of o.split("&")) {
			if (e === "") continue;
			let n = e.indexOf("="), r = n === -1 ? e : e.slice(0, n), i = n === -1 ? "" : e.slice(n + 1), a, o;
			try {
				a = decodeURIComponent(r), o = decodeURIComponent(i.replace(/\+/g, " "));
			} catch {
				a = r, o = i;
			}
			t.has(a.toLowerCase()) || t.set(a.toLowerCase(), o);
		}
	}
	return t;
}, r = (t, n) => {
	for (let r of e[n]) {
		let e = t.get(r);
		if (e !== void 0 && e !== "") return e;
	}
	return null;
}, i = (e) => {
	let i = n(e), a = r(i, "verified");
	return {
		purpose: r(i, "purpose"),
		verified: a !== null && t.has(a.toLowerCase()),
		transactionId: r(i, "transactionId"),
		resultToken: r(i, "resultToken"),
		code: r(i, "code")
	};
}, a = (e) => [...n(e).keys()].sort();
//#endregion
export { i as parsePasskeyReturn, a as passkeyReturnKeys };
